<template>
  <b-overlay
    :show="loader.formulario"
    rounded="sm"
  >
    <div v-if="infokardex.alumno">
      <validation-observer ref="simpleRules">
        <form-wizard
          color="#51b83e"
          :title="null"
          :subtitle="null"
          finish-button-text="Terminar"
          back-button-text="Anterior"
          next-button-text="Siguiente"
          class="vertical mb-3"
          @on-complete="validationForm(infokardex)"
        >

          <!-- Instrucciones cambio tab -->
          <tab-content title="Instrucciones">
            <b-row class="m-2">
              <b-col
                cols="12"
              >
                <h4> Instrucciones</h4>
              </b-col>
            </b-row>
            <b-row class="m-2">
              <b-col
                md="12"
              >
                <p> <strong>Antes de iniciar, lee con atención.</strong> </p>
                <p>
                  1: Para poder realizar este proceso, asegurate de que exista <strong>evidencia</strong>
                  por parte del alumno <strong> {{ infokardex.alumno.nombre }} </strong> <strong> {{ infokardex.alumno.segundoNombre }} </strong> <strong> {{ infokardex.alumno.apellidoPaterno }} </strong>
                  <strong> {{ infokardex.alumno.apellidoMaterno }} </strong> con matricula <strong> {{ infokardex.alumno.matricula }} </strong>
                  que <strong>justifique</strong> la modificación de su calificación;
                  así como una previa <strong> autorización </strong> por parte de Control Escolar y el Comité de Honor y Justicia.
                </p>
                <p>
                  2: Cualquier cambio de calificación sin tomar en consideración lo anterior,
                  sera sujeto a una penalización, <strong>todo movimiento es auditado y se encuetrá en base de datos.</strong>
                </p>
                <p>
                  3: Al continuar con este proceso usted se compromete hacer buen uso de la plataforma con responsabilidad y ética.
                </p>
              </b-col>
            </b-row>
          </tab-content>

          <!-- solicitud de cambio tab -->
          <tab-content title="Solicitud de Cambio">
            <b-row class="m-2">
              <b-col
                cols="12"
              >
                <h4>
                  Generar la solicitud de cambio ante el Comité de Honor y Justicia.
                </h4>
              </b-col>
            </b-row>
            <b-row class="m-2">
              <b-col
                md="12"
              >
                <p>
                  Completa los siguientes campos.
                  En este paso se creará una solicitud de <strong> cambio de calificacion </strong> ante el Comité de Honor y Justicia
                  el cual deberá de estar enterado previo a la realización de este proceso, ya que el CHYJ firma
                  todas aquellas calificaciones que fueron modificadas en el periodo.
                </p>
                <p class="m-0">
                  Periodo: <strong>{{ infokardex.kardex.periodoClave }} </strong>
                </p>
                <p class="m-0">
                  Status: <strong> {{ infokardex.kardex.status }}  </strong> {{ infokardex.kardex.descripcion }} </p>
                <p class="m-0">
                  Calificación: <strong>{{ infokardex.kardex.cal_fin }}</strong>
                </p> <p class="m-0">
                  Nivel de Cuatrimeste: <strong> {{ infokardex.kardex.orden }} </strong>
                </p>
                <p> Materia: <strong>{{ infokardex.kardex.nombre_materia }} </strong></p>
              </b-col>
            </b-row>
            <b-row class="m-2">
              <b-col
                md="12"
              >
                <b-form-group
                  label="Fecha de la solicitud"
                  label-for="fechasolicitud"
                  label-cols-md="2"
                > <validation-provider
                  #default="{ errors }"
                  name="fecha de solicitud"
                  rules="required"
                >
                  <flat-pickr
                    v-model="formulario.dateNtimsol"
                    class="form-control"
                    autocomplete="off"
                    :config="configFlatPickr"
                    placeholder="Ingresa una fecha y hora de la solicitud de cambio"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="m-1">
              <b-col
                md="12"
              >
                <b-form-group
                  label="Solicitante"
                  label-for="solicitante"
                  label-cols-md="2"
                >
                  <b-form-select
                    v-model="formulario.solicita"
                    :options="solicitantes"
                    value-field="solicita"
                    text-field="solicita"
                    :state="formulario.solicita === null ? false : true"
                    required
                  >
                    <template #first>
                      <b-form-select-option
                        :value="null"
                        disabled
                      >
                        -- Selecciona el solicitante --
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="m-1">
              <b-col md="12">
                <b-form-group
                  label="Argumento"
                  label-for="argumento"
                  label-cols-md="2"
                >
                  <b-form-textarea
                    id="argumento"
                    v-model="formulario.argumento"
                    placeholder="Mensaje minimo 10 cracteres"
                    rows="3"
                    max-rows="8"
                    :state="formulario.argumento.length >= 10"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </tab-content>
          <!-- resolución tab -->
          <tab-content title="Resolución del Comité">
            <b-row class="m-1">
              <b-row class="m-2">
                <b-col>
                  <h4>
                    Resolución del Comité de Honor y Justicia.
                  </h4>
                </b-col>
              </b-row>
              <b-col
                md="12"
              > <p>En este paso, realizamos la resolución del Comité de Honor y Justicia, debemos indicar:</p>
                <p> - Si procede el cambio.  - El valor de la nueva calificación. - Una Observación (Justificación del cambio). - Fecha de resolución. </p>
              </b-col>
              <b-col
                md="12"
              >
                <b-form-checkbox
                  v-model="formulario.resolucion"
                  class="mb-1 switchred"
                  unchecked-value="0"
                  value="1"
                  switch
                > Esta Solicitud es:
                  <span v-if="formulario.resolucion == 0">ACEPTADA</span>
                  <span v-if="formulario.resolucion == 1">RECHAZADA</span>
                </b-form-checkbox>
              </b-col>
              <b-col
                md="12"
              >
                <b-form-group
                  label="Calificación"
                  label-for="calificacion1"
                  label-cols-md="2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="calificación"
                    rules="required|between:0,100"
                  >
                    <b-form-input
                      id="nombre"
                      v-model="formulario.nuevacalif"
                      placeholder="Valor de la nueva calificación"
                      :state="errors.length > 0 ? false:null"
                      autocomplete="off"
                      type="number"
                      max="100"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                md="12"
              >
                <b-form-group
                  label="Fecha de la resolución"
                  label-for="fecha de resolución"
                  label-cols-md="2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="fecha de resolución"
                    rules="required"
                  >
                    <flat-pickr
                      v-model="formulario.dateNtim"
                      class="form-control"
                      :config="configFlatPickr"
                      placeholder="Ingresa una fecha y hora de resolución de la solicitud de cambio"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Observación CHYJ"
                  label-for="observacion"
                  label-cols-md="2"
                >
                  <b-form-textarea
                    id="observacion"
                    v-model="formulario.observacion"
                    placeholder="Mensaje minimo 10 caracteres"
                    :state="formulario.observacion.length >= 10"
                    rows="3"
                    max-rows="8"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </tab-content>

          <tab-content title="Cambiar Status del kardex">
            <b-row class="m-1">
              <b-row class="m-2">
                <b-col
                  cols="12"
                >
                  <h4>
                    Asignar un status nuevo o mantener el actual en el la calificación del Kardex seleccionado.
                  </h4>
                </b-col>
              </b-row>
              <b-row class="m-2">
                <b-col
                  md="12"
                >
                  <p>
                    En Este paso puedes actualizar el estado de la calificación del Kardex, recuerda que la autoridad considera como <strong> Mínima calificación aprobatoria 80 </strong> y la Máxima 100
                  </p>
                </b-col>
                <b-col
                  md="12"
                >
                  <b-form-group
                    label="Estado de la calificación en kardex"
                    label-for="estadokardex"
                  >
                    <b-form-select
                      v-model="formulario.statusk"
                      :options="statuskdx"
                      value-field="id"
                      text-field="descripcion"
                      :state="formulario.statusk === null ? false : true"
                      required
                    >
                      <template #first>
                        <b-form-select-option
                          :value="null"
                          disabled
                        >
                          -- Selecciona el estado de la calificación en kardex --
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-row></tab-content>

        </form-wizard>

      </validation-observer>
    </div>
  </b-overlay>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BFormTextarea,
  BFormCheckbox,
  BOverlay,
} from 'bootstrap-vue'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getData, postData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import {
  ref, onMounted, getCurrentInstance, watch,
} from '@vue/composition-api'
import flatPickr from 'vue-flatpickr-component'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import store from '@/store'

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BFormCheckbox,
    BOverlay,
  },
  props: {
    infokardex: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },

  setup(props) {
    const toast = useToast()
    const solicitantes = ref(['PROF', 'ALU', 'CHYJ'])
    const statuskdx = ref([])
    const simpleRules = ref(null)
    const formulario = ref({
      solicita: null,
      argumento: '',
      observacion: '',
      resolucion: 0,
      dateNtim: null,
      statusk: null,
      nuevacalif: null,
      dateNtimsol: null,
      alumno: {},
      kardex: {},
    })
    const loader = { formulario: false }
    const errorpage = false
    const configFlatPickr = {
      enableTime: true, enableSeconds: true, altInput: true, minuteIncrement: 1, altFormat: 'd-m-Y H:i:s', dateFormat: 'U',
    }
    // eslint-disable-next-line no-unused-vars
    const vm = getCurrentInstance().proxy
    const getstatuskdx = () => {
      loader.formulario = true
      const paramsRequest = {
        action: 3,
        token: store.state.cuenta.session.token,
      }
      getData(paramsRequest, 'wsadinterna')
        .then(response => {
          if (response.data.status === 200) {
            statuskdx.value = response.data.data || []
            loader.formulario = false
            toast({
              component: ToastificationContent,
              props: {
                title: 'Estados del kardex encontrados',
                text: response.data.message,
                icon: 'AlertCircleIcon',
                variant: 'success',
              },
            },
            { timeout: 10000 })
            return true
          }
          loader.formulario = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Estados del kardex no encontrados',
              text: response.data.message,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
          return false
        })
        .catch(error => {
          loader.formulario = false
          toast({
            component: ToastificationContent,
            props: {
              title: error,
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
      return true
    }
    const cancelar = () => {
      loader.formulario = false
      vm.$swal({
        title: 'Cancelado',
        html: '<b> La calificación no fue modificada </b>',
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    }
    const formSubmitted = datos => {
      vm.$swal({
        title: '¿Deseas Confirmar?',
        html: `Se modficará la calificación de la materia <b>${datos.kardex.nombre_materia}</b> en el periodo periodo <b>${datos.kardex.periodoClave}</b>
        del alumno <b>${datos.alumno.nombre} ${datos.alumno.segundoNombre} ${datos.alumno.apellidoPaterno} ${datos.alumno.apellidoMaterno}</b> 
        con matricula <b>${datos.alumno.matricula}</b>, calificación <b>original</b> ${datos.kardex.cal_fin} <b>nueva</b> calificación ${formulario.nuevacalif}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, Monificar la Calificación!',
        cancelButtonText: 'No Cancelar!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          loader.formulario = true
          const params = new FormData()
          formulario.value.alumno = datos.alumno
          formulario.value.kardex = datos.kardex
          params.append('task', 'wsadinterna')
          params.append('origin', process.env.VUE_APP_ORIGIN_API)
          params.append('token', store.state.cuenta.session.token)
          params.append('action', 4)
          params.append('datos', JSON.stringify(formulario))
          postData(params)
            .then(response => {
              if (response.data.status === 200) {
                vm.$swal({
                  icon: 'success',
                  title: 'Calificación Modificada!',
                  html: ' Importante te sugerimos verificar el cambio, vuleve a buscar la matricula del alumno para visualizar su kardex actualizado',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              } else {
                toast({
                  component: ToastificationContent,
                  props: {
                    title: response.data.message,
                    icon: 'EditIcon',
                    variant: 'danger',
                  },
                })
              }
              loader.formulario = false
            })
            .catch(err => {
              cancelar()
              toast({
                component: ToastificationContent,
                props: {
                  title: err,
                  icon: 'EditIcon',
                  variant: 'danger',
                },
              })
            })
        } else if (result.dismiss === 'cancel') cancelar()
      })
    }
    const validationForm = info => {
      simpleRules.value.validate().then(success => {
        if (success && formulario.value.dateNtimsol <= formulario.value.dateNtim) formSubmitted(info)
        else {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Completa todos los campos y asegurate que la Fecha de Solicitud sea menor a la Fecha de Resolución',
              icon: 'EditIcon',
              variant: 'danger',
            },
          })
        }
      })
    }
    onMounted(
      () => {
        getstatuskdx()
      },
    )

    watch(() => props.infokardex, data => {
      if (data.kardex) formulario.value.statusk = data.kardex.status
      else formulario.value.statusk = null
    })
    return {
      solicitantes,
      getstatuskdx,
      formSubmitted,
      statuskdx,
      formulario,
      loader,
      errorpage,
      cancelar,
      configFlatPickr,
      validationForm,
      simpleRules,
      required,
    }
  },
}

</script>
<style lang="scss">
.switchred .custom-control-input:checked ~ .custom-control-label::before  {
    background-color: #ff0000;
}

@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
